<!-- *ngIf="popupPermissions.length > 0 &&  showPopup" -->
<div>
  <div class="modal fade show" tabindex="-1" aria-labelledby="business-partners-modalLabel" aria-hidden="true"
    [ngStyle]="{'display': 'block'}">

    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header float-end">
          <div class="d-flex w-100">
            <div class="me-2 id flex-fill">
                <h4 class="modal-title mb-0 item-id text-center">
                  Sign within the area
                </h4>
            </div>

            <div class="btns-header">
                <button
                    class="header-icon close p-0 m-0"
                    (click)="close()"
                    aria-label="Close"
                >
                    <i
                        class="fas fa-times"
                        title="Close Popup"
                    ></i>
                </button>
            </div>
        </div>
      </div>




        <div class="modal-body pt-0">
          <div class="row">
            <div class="col-12 d-flex justify-content-center p-5">
              <canvas ejs-signature width="620px" height="330px" #signature (contextmenu)="$event.preventDefault();" (change)="changeSignature()"></canvas>
            </div>
          </div>
        </div>


        <div class="modal-footer d-flex justify-content-center">
          <!-- [disabled]="!isFormUpdated || !getPermission('bpPopup_btn_save').enable" -->
          <button type="button" class="btn btn-sm btn-danger close-modal px-4 me-2" (click)="signatureCanvas.clear(); isSignatureChanged = true;">Clear</button>
          <button type="button"
            class="btn btn-sm btn-success close-modal px-4" [disabled]="!isSignatureChanged || signatureCanvas.isEmpty()" (click)="saveSignature()">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
